import {html} from 'lit';

export default function() {
    return html`
        <app-header role="banner"></app-header>
        <main id="appMain" class="app-main"></main>
        <app-mobile-navigation></app-mobile-navigation> 
    `;
}